const imageSizes = require('./constants/image.json');

const BREAKPOINTS_DEVICES = {
  MOBILE: 320,
  MOBILEBIG: 480,
  PHABLET: 660,
  TABLET: 768,
  DESKTOP: 960,
  WIDE: 1366
};

const FOOTER_DATA = {
  MENUS: [
    { href: '/contact-us', name: 'Contact' },
    { href: '/terms-conditions', name: 'Terms & Conditions' },
    { href: '/privacy', name: 'Privacy Policy' },
    { href: '/cookies', name: 'Cookie Policy' }
  ],
  COPYRIGHT: '© 2021 Speakers Corner. All rights reserved.'
};

const HEADER_MENUS = [
  {
    name: 'News',
    href: '/news'
  },
  {
    name: 'Speaker Topics',
    href: '/topics',
    items: [
      { itemKey: 1, href: '/topics/adventure', name: 'Adventure' },
      { itemKey: 2, href: '/topics/change', name: 'Change' }
    ]
  },
  {
    name: 'Contact',
    href: '/contact-us'
  }
];

const SOCIAL_DATA = [
  {
    href: ' https://www.facebook.com/Speakers-Corner-186751064681803',
    name: 'facebook',
    socialClass: 'facebook-f'
  },
  { href: 'https://twitter.com/Speakers_Corner', name: 'twitter', socialClass: 'twitter' },
  {
    href: 'https://www.instagram.com/speakerscornerbureau/',
    name: 'instagram',
    socialClass: 'instagram'
  }
];

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? null
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1280
            }
          }
        },
        'card:portrait:grid--one': {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        'card:portrait:grid--one:related-videos': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 20vw'
        },
        'card:portrait:grid--one:sidebar-card': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 20vw'
        },
        'card:portrait:grid--one:carousel': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 20vw, 50vw'
        },
        'card:portrait:grid--two': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--three:review card--animated-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--four': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw'
        },
        'card:portrait:grid--four:shadow-border': {
          widths: imageSizes.landscape,
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw'
        },
        'card:portrait:grid--four:speakers': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            },
            '420w': {
              r: {
                width: '420',
                height: '420'
              }
            },
            '520w': {
              r: {
                width: '520',
                height: '520'
              }
            }
          },
          sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 10vw'
        },
        'card:landscape:grid--two': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 40vw, 10vw'
        },
        'card:landscape:grid--one': {
          widths: imageSizes.standardWidths,
          sizes: '40vw'
        },
        'card:landscape:grid--two:testimonials': {
          widths: {
            '200w': {
              r: {
                width: '200',
                height: '200'
              }
            }
          },
          sizes: '20vw'
        },
        card: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:responsive': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:responsive min-aspect': {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:content-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 660px) 100vw, 768px'
        },
        'image:speaker-profile-image': {
          widths: imageSizes.standardWidths,
          sizes: '(max-width: 768px) 100vw, 20vw'
        },
        'image:image--speaker': {
          widths: {
            '320w': {
              r: {
                width: '320',
                height: '320'
              }
            }
          },
          sizes: '100vw'
        },
        carousel: {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        },
        'card:portrait:grid--one:two-line-cards': {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        }
      }
    };

export { BREAKPOINTS_DEVICES, FOOTER_DATA, HEADER_MENUS, SOCIAL_DATA, RESPONSIVE_IMAGE_CONFIG };
